module.exports = __webpack_public_path__ + "static/media/offer.7d8fe91e.png";